// extracted by css-extract-rspack-plugin
export default {"buttonContainer":"popout-player-dialog-module__buttonContainer___XxkcH","messageContainer":"popout-player-dialog-module__messageContainer___dAL3r"};